import { Controller } from 'stimulus';
import { getAppliedParams } from '../packs/filter_helpers';

export default class extends Controller {
  static targets = ["savedSearchField", "filterComponentField", "componentTypeField", "allFiltersField", "graphConfigFields", "textField", "statsField"];

  initialize() {
    this.toggleSavedSearchOptionsDisplay();
    this.render_filter_url = window.location.pathname.replace("/edit", "") + "/render_filter"
  }

  connect() {
    let controller = this;

    $(this.allFiltersFieldTarget).find("input:checked").each(function(j, el){
      let filter_type = $(el).val();
      let selected_values_input = $(el).parent().find(`label input.${filter_type}-selected-values`);
      let selected_values = selected_values_input.val();
      let param_name = selected_values_input.data("paramName");
      let params = {}

      if(selected_values){
        params[param_name] = selected_values.split(",")
        if(filter_type.includes("attribute-key")){
          params[param_name] = selected_values
        }
      }

      controller.appendFilterPartial($(el), params, filter_type)
    })
  }

  toggleValueSelectField(event){
    let filter_type = $(event.target).val()

    if($(event.target).is(":checked")){
      let params = {}
      this.appendFilterPartial($(event.target), params, filter_type)
    } else {
      $(this.allFiltersFieldTarget).find(".select_value_fields").find(`.${filter_type}`).remove()
      $(event.target).parent().find("label .selected-count").hide()
    }
    
  }

  appendFilterPartial(target, params, filter_type){
    params["filter_type"] = filter_type;
    params["ajax_action"] = "component-forms#UpdateFieldSelection";
    Rails.ajax({
      type: 'GET',
      url: this.render_filter_url,
      data: $.param(params),
      dataType: 'json',
      success: (response) => {
        $(this.allFiltersFieldTarget).find(".select_value_fields").append(`<div data-filter-type='${filter_type}' data-param-name='${response.param_name}' class="mt-2 filter-container ${filter_type}">${response.template}</div>`)
        target.parent().find("label .selected-count").show()
      }
    });
  }

  UpdateFieldSelection(event){
    event.preventDefault();

    let filter_container = $(event.target).parents(".filter-container")
    let param_name = filter_container.data("paramName");
    let filter_type = filter_container.data("filterType");

    let applied_params = getAppliedParams(event, filter_container, param_name)
    this.reRenderFilterPartial(filter_container, applied_params)

    let selected_count_element = $(this.allFiltersFieldTarget).find(`label span.${filter_type}-selected-count`);
    let selected_values_element = $(this.allFiltersFieldTarget).find(`label input.${filter_type}-selected-values`);

    let selected_count = 0
    let param_value = applied_params[param_name]
    if(Array.isArray(param_value)){
      selected_count = param_value.length
    } else if(typeof(param_value) == "string"){
      selected_count = param_value.split(",").length
    }

    selected_count_element.text(`(${selected_count} Selected)`)

    if(selected_count > 0){
      selected_values_element.val(param_value)
    }
  }

  reRenderFilterPartial(filter_container, applied_params) {
    applied_params["param_name"] = filter_container.data("paramName");
    applied_params["filter_type"] = filter_container.data("filterType");
    applied_params["ajax_action"] = "component-forms#UpdateFieldSelection";
    Rails.ajax({
      type: 'GET',
      url: this.render_filter_url,
      data: $.param(applied_params),
      dataType: 'json',
      success: (response) => {
        filter_container.html(response.template)

        //update button text
        let button = filter_container.find("button.dropdown-toggle")
        let button_text = button.find("span").text()
        let index = button_text.indexOf(":")

        let pretext = button_text.slice(0, index)
        let selection_text = button_text.slice(index + 1).trim()

        if (selection_text.length > 30) {
          selection_text = selection_text.slice(0, 30) + '...';
        }

        button.text(pretext + ": " + selection_text)
      }
    });
  }

  toggleSavedSearchOptionsDisplay(){
    $(this.savedSearchFieldTarget).find("optgroup[label='Posts']").hide();
    $(this.savedSearchFieldTarget).find("optgroup[label='Channels']").hide();
    $(this.savedSearchFieldTarget).find("optgroup[label='Actors']").hide();

    if(this.componentTypeFieldTarget.value == "channel_list"){
      $(this.savedSearchFieldTarget).find("optgroup[label='Posts']").show();
      $(this.savedSearchFieldTarget).find("optgroup[label='Channels']").show();
    } else if(this.componentTypeFieldTarget.value == "actor_list"){
      $(this.savedSearchFieldTarget).find("optgroup[label='Actors']").show();
    } else {
      $(this.savedSearchFieldTarget).find("optgroup[label='Posts']").show();
    }
  }

  updateComponentType(event) {
    let value = event.target.value
    this.toggleSavedSearchOptionsDisplay();

    $(this.graphConfigFieldsTarget).hide();
    $(this.savedSearchFieldTarget).hide();
    $(this.filterComponentFieldTarget).hide();
    $(this.allFiltersFieldTarget).hide();
    $(this.textFieldTarget).hide();
    $(this.statsFieldTarget).hide();

    if (value.includes("filter_container")){
      $(this.allFiltersFieldTarget).show();

      $(this.allFiltersFieldTarget).find("select").select2({
        theme: "bootstrap4",
      });

    } else if (value.includes("_filter")){
      
    } else if (value.includes("heading_and_text")){
      $(this.textFieldTarget).show();
    } else if (value.includes("statistics")){
      $(this.statsFieldTarget).show();
    }
    else {
      if(value == "chart") { $(this.graphConfigFieldsTarget).show() }
      $(this.savedSearchFieldTarget).show()
      $(this.filterComponentFieldTarget).show()
    }
  }
}